import styled from 'styled-components';
import { LayoutItem } from '@oneaudi/unified-web-components';

import React, { HTMLAttributes } from 'react';

export type LayoutContainerProps = HTMLAttributes<HTMLDivElement> & {
  theme: any;
  style?: any;
};
export const LayoutContainer = styled<React.FC<LayoutContainerProps>>(LayoutItem)`
  ${(props) => props.style}
`;
